import React from 'react';
import Hero from '../components/Hero';
import SolutionsOverview from '../components/SolutionsOverview';
import FeaturedProjects from '../components/FeaturedProjects';
import ProductShowcase from '../components/ProductShowcase';
import Partnerships from '../components/Partnerships';
import CTASection from '../components/CTASection';

const HomePage = ({ onGetQuoteClick }) => {
  return (
    <>
      <Hero />
      <SolutionsOverview />
      <FeaturedProjects />
      <ProductShowcase />
      <Partnerships />
      <CTASection onGetQuoteClick={onGetQuoteClick} />
    </>
  );
};

export default HomePage;
